import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=cb9d9dfe&scoped=true&"
import script from "./UserCreate.vue?vue&type=script&lang=js&"
export * from "./UserCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9d9dfe",
  null
  
)

export default component.exports